/*
 * GUID
 */
function guid () {
  function S4 () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}

/*
 * 显示loading遮罩层
 */
function loading () {
  var id = guid()

  var maskBg = document.createElement('div')
  maskBg.id = 'mask_bg_' + id
  maskBg.style.position = 'absolute'
  maskBg.style.top = '0px'
  maskBg.style.left = '0px'
  maskBg.style.width = '100%'
  maskBg.style.height = '100%'
  maskBg.style.backgroundColor = '#777'
  maskBg.style.opacity = 0.6
  maskBg.style.zIndex = 10001
  document.body.appendChild(maskBg)

  var maskMsg = document.createElement('div')
  maskMsg.style.position = 'absolute'
  maskMsg.style.top = '43%'
  maskMsg.style.left = '43%'
  maskMsg.style.textAlign = 'center'
  maskMsg.style.zIndex = 10002

  var image = document.createElement('img')
  image.src = '/images/rotate_loader.svg'
  maskMsg.appendChild(image)

  maskBg.appendChild(maskMsg)

  return maskBg.id
}
/*
 * 关闭遮罩层
 */
function loaded (id) {
  var maskBg = document.getElementById(id)
  if (maskBg != null) {
    maskBg.parentNode.removeChild(maskBg)
  }
}

export {loading, loaded}
